import * as React from 'react';
import { connect } from 'react-redux';
import AppState from '@webapp/store/state';
import { showMainLoader } from '@webapp/store/ui/selectors';

import ModalBackground from '@components/ui/modal';
import LogoLoadingCtrl from './logo';

interface LoadingModalCtrlProps {
  loading: boolean;
}

const mapStateToProps = (state: AppState) => ({
  loading: showMainLoader(state),
});

export const LoadingModalCtrl: React.FC<LoadingModalCtrlProps> = (props) => {
  return (
    <ModalBackground active={props.loading}>
      <LogoLoadingCtrl
        className={props.loading ? 'loading' : 'paused'}
        loading={props.loading}
      />
    </ModalBackground>
  );
};

export default connect(mapStateToProps)(LoadingModalCtrl);
